// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_REPORTED = "nahl\u00e1sen\u00e9";
export const SHOW = "Zobraz";
